var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M43.2 4H4.8C2.153 4 0 6.242 0 9v30c0 2.758 2.153 5 4.8 5h38.4c2.647 0 4.8-2.242 4.8-5V9c0-2.758-2.153-5-4.8-5M42 7a3 3 0 0 1 3 3v.277L24 25.836 3 10.28V10a3 3 0 0 1 3-3zM6 41a3 3 0 0 1-3-3V14l19.526 14.47c.42.343.94.53 1.474.53s1.053-.187 1.474-.53L45 14v24a3 3 0 0 1-3 3z"
  })));
};
export default SvgMail;